import React from 'react';

export function GlassPanel({ 
  children, 
  className = '', 
  title,
  titleIcon: TitleIcon,
  headerAction,
  headerRight,
  ...props 
}) {
  return (
    <div className={`glass-panel ${className}`} {...props}>
      {title && (
        <div className="glass-panel-header">
          <h3 className="glass-panel-title">
            {TitleIcon && <TitleIcon size={18} className="icon" />}
            {title}
          </h3>
          {headerAction || headerRight}
        </div>
      )}
      {children}
    </div>
  );
}

export default GlassPanel;
